import isMobile from "is-mobile";
import { getMobilePlatform } from "../utils/getMobilePlatform";
import { useEffect, useState } from "react";

const KiralaGelBanner = ({ src, listingPage, roundedClass, deviceType }) => {
  const [href, setHref] = useState("https://www.kiralagel.com");

  const isWide = src?.includes("1350x210");
  const aspectClass = isWide ? "aspect-[1350/210]" : "aspect-[575/260]";

  useEffect(() => {
    const isPhone = isMobile();
    const platform = getMobilePlatform();

    const mobileHref =
      platform === "ios" || deviceType === "ios"
        ? "https://apps.apple.com/us/app/kiralagel/id6762357016"
        : "https://play.google.com/store/apps/details?id=com.boceksoftware.kiralagelapp";

    setHref((isPhone || deviceType) ? mobileHref : "https://www.kiralagel.com");
  }, [deviceType]);

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={`block w-full ${aspectClass} bg-contain bg-no-repeat bg-center relative ${roundedClass} ${listingPage ? "" : " my-6 xl:my-10"}`}
      style={{ backgroundImage: `url(${src})` }}
    >
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 text-[rgba(52,55,56,1)] bg-white/60 backdrop-blur- z-10 px-4 sm:px-8 py-2 sm:py-3 rounded-full font-bold shadow-xl transform transition-all duration-300 hover:bg-white hover:scale-105 active:scale-95 whitespace-nowrap text-sm lg:text-base tracking-wide">
        Bilgi al
      </div>
    </a>
  );
};

export default KiralaGelBanner;
